var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DE758C",
    d: "M25.392 13.051c0 .554-.242 1.077-.662 1.44-1.28 1.105-4.467 3.245-9.963 3.245-5.423 0-8.48-2.085-9.73-3.203-.43-.384-.673-.935-.673-1.513V5.127h21.028v7.924z",
    transform: "translate(.278 .45)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8752A1",
    d: "M29.247 4.17c1.56.526 1.56 1.387 0 1.912L18.044 9.86c-1.56.525-4.111.525-5.671 0L1.17 6.082c-1.56-.525-1.56-1.386 0-1.911L12.373.394c1.56-.525 4.111-.525 5.67 0l11.204 3.777z",
    transform: "translate(.278 .45)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8752A1",
    d: "M27.425 5.232L27.425 16.123 28.262 16.123 28.262 5.021z",
    transform: "translate(.278 .45)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8752A1",
    d: "M27.878 17.736c.745 0 1.35-.605 1.35-1.35 0-.745-.605-1.35-1.35-1.35-.746 0-1.35.605-1.35 1.35 0 .745.604 1.35 1.35 1.35",
    transform: "translate(.278 .45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudents);
export default __webpack_public_path__ + "static/media/students.be39cddc24e9a7b804310dfb4395a000.svg";
export { ForwardRef as ReactComponent };